/**
 * Mesai kaydındaki okutma konumu için Google Haritalar bağlantısı (QR Mesai Faz 2, 18.10.2026).
 * "Haritada gör" yeni sekmede açılır: https://www.google.com/maps?q=lat,lon
 */

const sayiMi = (n: number | null | undefined): n is number => typeof n == 'number' && isFinite(n);

/** Geçerli enlem / boylam çifti mi (enlem -90..90, boylam -180..180; 0,0 konum alınamamış sayılır). */
export const konumGecerliMi = (lat: number | null | undefined, lon: number | null | undefined): boolean =>
    sayiMi(lat) && sayiMi(lon) && lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180 && !(lat == 0 && lon == 0);

/** Konum geçerliyse Google Haritalar adresi, değilse undefined. */
export const googleHaritaBaglantisi = (lat: number | null | undefined, lon: number | null | undefined): string | undefined =>
    konumGecerliMi(lat, lon) ? `https://www.google.com/maps?q=${lat},${lon}` : undefined;

/** Uzaklık metni: 1000 m altı "40 m", üstü "1,2 km"; boşsa ''. */
export const mesafeMetni = (metre: number | null | undefined): string => {
    if (!sayiMi(metre) || metre < 0)
        return '';

    if (metre < 1000)
        return Math.round(metre) + ' m';

    return (Math.round(metre / 100) / 10).toLocaleString('tr-TR', { maximumFractionDigits: 1 }) + ' km';
}
